// import { reactive } from 'vue'

// export const store = reactive({
//     organization: 0,
//     access_token: '',
//     perPage: 15,
//     showDetails: false
// })


import { defineStore } from 'pinia'

export const useStore = defineStore('main', {
    state: () => {
        return {
          role: 'User',
          organization: 0,
          access_token: '',
          perPage: 15,
          showDetails: false,
          reportStartDate: '',
          reportEndDate: '',
          reportOrderBy: '',
          reportOffset: 0,
          reportCount: 0,
          theme: '',
          projectPageCompany: null,
          reportPageCompany: null,
          reportPageMember: null,
          reportPageProject: null
        }
      },
      persist: true
})